import Layout from "@/views/layout/index";

const serviceCenter = [
  {
    path: "/serviceCenter",
    name: "ServiceCenter",
    component: Layout,
    // hidden: true,
    isChildren: false,
    mCode: "HBGKFWZX",
    meta: { title: '湖北港口服务中心', icon: 'dashboard' },
    children: [
      {
        path: '/serviceCenter',
        component: () => import('@/views/serviceCenter/index'),
      },
    ]
  },
]

export default serviceCenter




// WEBPACK FOOTER //
// ./src/router/serviceCenter/index.js